module.exports = __webpack_public_path__ + "media/images/lb/907-73d8b459b66ad429ca0676839bf499bd.svg";